import React from 'react';

export const SpinnerContext = React.createContext({
  showSpinner: false,

 changeSpinnerStatus: (show) => {console.log(show)}
});
